import { differenceInCalendarDays, format, parseISO, startOfDay } from 'date-fns';

import type { SunsetInfo } from '../types';

/**
 * Calculate sunset information from a graduation date string.
 * Returns null if no graduation date is configured.
 */
export function calculateSunsetInfo(
  graduationDateStr?: string,
  legacyName = 'Classic',
): SunsetInfo | null {
  if (!graduationDateStr) return null;

  const graduationDate = parseISO(graduationDateStr);
  const today = startOfDay(new Date());
  const daysRemaining = differenceInCalendarDays(graduationDate, today);
  const isPastDue = daysRemaining <= 0;

  let label: string;
  if (isPastDue) {
    label = `${legacyName} has been sunset`;
  } else if (daysRemaining === 1) {
    label = `${legacyName} sunsets tomorrow`;
  } else if (daysRemaining < 7) {
    label = `${legacyName} sunsets in ${daysRemaining} days`;
  } else {
    label = `${legacyName} sunsets ${format(graduationDate, 'MMMM d')}`;
  }

  return { graduationDate, daysRemaining, isPastDue, label };
}

/**
 * Determine if a periodic nudge should fire based on interval and last nudge timestamp.
 */
export function shouldPeriodicNudge(
  intervalMs?: number,
  lastPeriodicNudgeAt?: number,
): boolean {
  if (!intervalMs || intervalMs <= 0) return false;
  if (!lastPeriodicNudgeAt) return true;
  return Date.now() - lastPeriodicNudgeAt >= intervalMs;
}
